module.exports = __webpack_public_path__ + "img/瞿麦.82ca9fc6.jpg";